@let color = '#F0F0F0';
@let size = 200;
<svg [attr.width]="size" [attr.height]="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter id="innerShadow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceAlpha" stdDeviation="0.4" result="blur" />
      <feOffset dx="0.15" dy="0.15" result="offsetBlur" />
      <feComposite in="SourceGraphic" in2="offsetBlur" operator="out" result="inverse" />
      <feFlood flood-color="#000" flood-opacity="0.2" result="color" />
      <feComposite in="color" in2="inverse" operator="in" result="shadow" />
      <feComposite in="shadow" in2="SourceGraphic" operator="over" />
    </filter>
  </defs>
  <path
    d="M14.7636 2.60354L9.69092 7.67547V8.32339L14.7644 13.3965H15.4116L16 12.8081V12.1601L12.1633 8.32339V7.67547L16 3.83952V3.1916L15.4116 2.60315L14.7636 2.60354Z"
    [attr.fill]="color"
    filter="url(#innerShadow)"
  />
  <path
    d="M0.588843 2.60352L0 3.19157V3.8395L3.83713 7.67544V8.32337L0.000393658 12.1601V12.808L0.588843 13.3961H1.23637L6.30909 8.32337V7.67544L1.23637 2.60352H0.588843Z"
    [attr.fill]="color"
    filter="url(#innerShadow)"
  />
  <path
    d="M7.67583 9.69092L2.60352 14.7644V15.4116L3.19196 16H3.83989L7.67623 12.1633H8.32415L12.1605 16H12.8088L13.3973 15.4116V14.7636L8.32376 9.69092H7.67583Z"
    [attr.fill]="color"
    filter="url(#innerShadow)"
  />
  <path
    d="M12.1605 0L8.32376 3.83674H7.67623L3.83989 0H3.19157L2.60352 0.588449V1.23637L7.67623 6.30909H8.32376L13.3973 1.23637V0.588449L12.808 0H12.1605Z"
    [attr.fill]="color"
    filter="url(#innerShadow)"
  />
</svg>
